<template>
    <div class="main">
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/report/arr_02.png" alt="">
            <div class="f-dfsb">
                <span class="time">{{time}}</span>
                <span class="daytotal">{{data.daytotal | moneyP}}</span>
            </div>
        </header>
        <div class="detailList">
            <div class="f-dfsb">
                <span class="name">{{data.clinicmergedesc}}</span>
                <span class="tt">本日总收入(元)</span>
            </div>

            <div class="drop_down">
                <transition name="draw">
                    <div class="listBox" v-if="show">
                        <ul class="drop_list">
                            <li class="f-dfa">
                                <div>
                                    <p class="num">{{data.monthtotal | moneyP}}</p>
                                    <p class="tt">月收入累计</p>
                                </div>
                                <div>
                                    <p class="num">{{data.monthdrugs | moneyP}}</p>
                                    <p class="tt">月药品累计</p>
                                </div>
                                <div>
                                    <p class="num">{{data.monthdrugsper | moneyP}}</p>
                                    <p class="tt">月药占比</p>
                                </div>
                            </li>
                            <li class="f-dfa f-mb0">
                                <div>
                                    <p class="num">{{data.medicalincome | moneyP}}</p>
                                    <p class="tt">医疗</p>
                                </div>
                                <div>
                                    <p class="num">{{data.drugsincome | moneyP}}</p>
                                    <p class="tt">药品</p>
                                </div>
                                <div>
                                    <p class="num">{{data.drugsper | moneyP}}%</p>
                                    <p class="tt">药占比</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
            <div class="imgBox" v-on:click="show = !show">
                <img class="dropImg" v-if="show" src="../../assets/jxwx/report/drop2.png" alt="">
                <img class="dropImg" v-else src="../../assets/jxwx/report/drop.png" alt="">
            </div>
        </div>
        <div class="control_box">
            <ul>
                <li class="tt">本日医保收入合计（元）</li>
                <li class="num">{{data.insuredincome | moneyP}}</li>
                <li class="per">
                    占比 {{data.insuredper | moneyP}}%
                </li>
            </ul>
            <ul>
                <li class="tt">本日非医保收入合计（元）</li>
                <li class="num">{{data.uninsuredincome | moneyP}}</li>
                <li class="per">
                    占比 {{data.uninsuredper | moneyP}}%
                </li>
            </ul>
        </div>
        <div class="u-card cardBox">
            <div class="bd">
                <div class="m-hos" v-if="data.towninhosquota == 0">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 住院-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.towninhosprop <= 80,'progress_bar3':data.towninhosprop >= 100}" :style="{width: data.towninhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.towninhosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">--</span>
                    </div>
                </div>
                <div class="m-hos" v-else>
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 住院-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.towninhosprop <= 80,'progress_bar3':data.towninhosprop >= 100}" :style="{width: data.towninhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{data.towninhosprop | moneyP}}%</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">{{data.towninhosquota | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.towninhosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">{{data.towninhossurplus | moneyP}}</span>
                    </div>
                </div>
                <div class="m-hos" v-if="data.resinhosquota == 0">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 住院-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.resinhosprop <= 80,'progress_bar3':data.resinhosprop >= 100}" :style="{width: data.resinhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.resinhosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">--</span>
                    </div>
                </div>
                <div class="m-hos" v-else>
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 住院-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.resinhosprop <= 80,'progress_bar3':data.resinhosprop >= 100}" :style="{width: data.resinhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{data.resinhosprop | moneyP}}%</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">{{data.resinhosquota | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.resinhosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">{{data.resinhossurplus | moneyP}}</span>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="bd">
                <div class="m-hos" v-if="data.townouthosquota == 0">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 门急诊-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.townouthosprop <= 80,'progress_bar3':data.townouthosprop >= 100}" :style="{width: data.townouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.townouthosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">--</span>
                    </div>
                </div>
                <div class="m-hos" v-else>
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 门急诊-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.townouthosprop <= 80,'progress_bar3':data.townouthosprop >= 100}" :style="{width: data.townouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{data.townouthosprop | moneyP}}%</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">{{data.townouthosquota | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.townouthosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">{{data.townouthossurplus | moneyP}}</span>
                    </div>
                </div>
                <div class="m-hos" v-if="data.resouthosquota == 0">
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 门急诊-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.resouthosprop <= 80,'progress_bar3':data.resouthosprop >= 100}" :style="{width: data.resouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">--</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.resouthosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">--</span>
                    </div>
                </div>
                <div class="m-hos" v-else>
                    <header class="f-df">
                        <img src="../../assets/jxwx/report/point.png" alt=""> 门急诊-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':data.resouthosprop <= 80,'progress_bar3':data.resouthosprop >= 100}" :style="{width: data.resouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次占比</span>
                        <span class="mark nm">{{data.resouthosprop | moneyP}}%</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次额度</span>
                        <span class="nm">{{data.resouthosquota | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">当前医保均次</span>
                        <span class="nm">{{data.resouthosavg | moneyP}}</span>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次剩余</span>
                        <span class="mark nm">{{data.resouthossurplus | moneyP}}</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            show: false,
            time: this.$route.query.time,
            data: this.$route.query.data
        };
    },
    mounted() {},
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        }

        // getDailyCountData() {
        //     let params = {
        //         date: this.time
        //     };
        //     api.getDailyCountData(params).then(res => {
        //         this.countData = res;
        //     });
        // },
    }
};
</script>

<style lang="less" scoped>
.main {
    padding-bottom: 8vw;
}
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 3.3vw;
    color: #fff;
    background: #5584ff;
    .f-dfsb {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .time {
        font-size: 12px;
    }
    .daytotal {
        font-size: 21px;
    }
    .tt {
        margin-left: 4vw;
    }
}
.detailList {
    padding: 0 3.3vw;
    color: #fff;
    background: #5584ff;
    .name {
        margin-left: 0.3vw;
        font-size: 16px;
    }
    .tt {
        margin-right: 1.7vw;
        font-size: 12px;
        color: #a6bdfa;
    }
    .drop_down {
        .listBox {
            overflow: hidden;
        }
        .drop_list {
            padding: 4vw 0 0 0;
            li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 3.2vw;
                border: 1px solid #2e68ff;
                border-radius: 6px;
                div {
                    flex: 1;
                    text-align: center;
                    p:first-child {
                        margin: 2vw 0 1vw 0;
                        font-size: 13px;
                    }
                    p:last-child {
                        margin: 1vw 0 2vw 0;
                        font-size: 12px;
                    }
                }
            }
            .f-mb0 {
                margin: 0;
            }
        }
    }
}
.imgBox {
    padding: 2vw 0;
    text-align: center;
    .dropImg {
        width: 2vw;
        height: 1vw;
    }
}
.control_box {
    display: flex;
    margin: 3.7333vw 2.5333vw;
    background: #f5e6d0;
    border-radius: 6px;
}
.control_box2 {
    margin: 0;
    background: #91c619;
    border-radius: 0;
}
.control_box > ul {
    flex: 1;
    text-align: center;
    padding-bottom: 3.0667vw;
}
.control_box > ul > .tt {
    padding: 3.4667vw 0 2.6667vw 0;
    font-size: 12px;
    color: #afafaf;
}
.control_box2 > ul > .tt {
    padding: 4.2667vw 0 3.2vw 0;
    font-size: 12px;
    color: #def0b6;
}
.control_box > ul > .num {
    padding: 0 0 2.1333vw 0;
    font-size: 21px;
    color: #f56b18;
}
.control_box2 > ul > .num {
    padding: 0 0 1.7333vw 0;
    color: #fff;
}
.control_box > ul > .per {
    width: 20.9333vw;
    margin: 0 auto;
    padding: 0.8vw 0;
    border: 1px solid rgba(196, 196, 196, 1);
    border-radius: 5px;
    font-size: 10px;
    color: #f56b18;
}
.control_box2 > ul > .per {
    width: 19.0667vw;
    margin: 0 auto;
    padding: 1.6vw 0;
    border: 1px solid #d9edaf;
    border-radius: 5px;
    font-size: 13px;
    color: #fff;
}

.line {
    margin: 0 -4vw;
    border-bottom: 1px solid #d4d4d4;
}

.u-card {
    margin: 2.6vw 4vw 0 4vw;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    // border-radius: 6px;
}
.cardBox {
    .hd {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            align-items: center;
            img {
                margin-right: 1.6vw;
            }
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 2vw 0 1.4vw 0;
        .m-hos {
            width: 50%;
            padding: 0 2vw;
            box-sizing: border-box;
            .f-df {
                display: flex;
                align-items: center;
            }
        }
        // .m-hos2 {
        //     width: 42vw;
        //     padding: 0 ;
        // }
        .m-hos header {
            margin-bottom: 3.4667vw;
            font-size: 14px;
            color: #4c4c4c;
        }
        .m-hos header img {
            width: 1.3333vw;
            margin-right: 1.3333vw;
        }
        .m-hos .progress {
            width: 100%;
            height: 2.1333vw;
            margin-bottom: 2.6667vw;
            border-radius: 1.0667vw;
            background-color: #efefef;
            overflow: hidden;
            .progress_bar {
                height: 100%;
                background-color: #fed100;
            }
            .progress_bar2 {
                height: 100%;
                background-color: #91C619;
            }
            .progress_bar3 {
                height: 100%;
                background-color: #F66969;
            }
        }

        .m-hos .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3.2vw;
            font-size: 12px;
        }
        .m-hos > .entry > .ctt {
            color: #8f8f8f;
        }
        .m-hos > .entry > .nm {
            font-size: 13px;
            color: #282828;
        }
        .m-hos > .entry > .mark {
            color: #f66969;
            // background: #fff;
        }
        .m-hos > .entry > .mark2 {
            color: #91c619;
        }
    }
}
.f-bc {
    padding: 2.6vw 0;
    background: #f7f7f7;
    .u-card {
        margin: 2.6vw 4vw;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
        border-radius: 6px;
    }
    .cardBox {
        .hd {
            display: flex;
            font-size: 13px;
            justify-content: start;
            align-items: center;
            height: 12vw;
            padding: 0 4vw;
            border-bottom: 1px solid #dedede;
            .icon {
                width: 4vw;
            }
            .tt {
                display: flex;
                justify-content: space-between;
                width: 45vw;
                margin: 0 3.2vw 0 1.6vw;
            }
            .arr {
                width: 1.3vw;
            }
        }
        .bd {
            display: flex;
            justify-content: space-between;
            padding: 4vw;
            .tt {
                margin-bottom: 3.2vw;
                font-size: 13px;
                color: #a6a6a6;
            }
            .num {
                font-size: 18px;
            }
        }
    }
}

.draw-enter-active,
.draw-leave-active {
    height: 34.8vw;
    opacity: 1;
    transition: all 0.5s;
}
.draw-enter,
.draw-leave-to {
    height: 0;
    opacity: 0;
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/groupDetails.vue